module.exports = "/assets/data/9bad15dd6ccf9fa9ce4af5f5fed10b40-CT21.data.json";